/* eslint-disable */
import EXIF from "@hysfront/exif-js"

window.URL = window.URL || window.webkitURL
/*

 * Create e Blob with the file data and get its url with window.URL.createObjectURL(blob)
 * Create new Image element and set it's src to the file blob url
 * Send the image to the canvas. The canvas size is set to desired output size
 * Get the scaled-down data back from canvas via canvas.toDataURL("image/jpeg",0.7) (set your own output format and quality)
 * Attach new hidden inputs to the original form and transfer the dataURI images basically as normal text
On backend, read the dataURI, decode from Base64, and save it
*/
var u = navigator.userAgent
var isIOS = u && /iPhone|iPad|iPod/gi.test(u)

function drawImageIOSFix(ctx, img) {
  var vertSquashRatio = detectVerticalSquash(img)
  var arg_count = arguments.length
  switch (arg_count) {
    case 4:
      ctx.drawImage(img, arguments[2], arguments[3] / vertSquashRatio)
      break
    case 6:
      ctx.drawImage(
        img,
        arguments[2],
        arguments[3],
        arguments[4],
        arguments[5] / vertSquashRatio
      )
      break
    case 8:
      ctx.drawImage(
        img,
        arguments[2],
        arguments[3],
        arguments[4],
        arguments[5],
        arguments[6],
        arguments[7] / vertSquashRatio
      )
      break
    case 10:
      ctx.drawImage(
        img,
        arguments[2],
        arguments[3],
        arguments[4],
        arguments[5],
        arguments[6],
        arguments[7],
        arguments[8],
        arguments[9] / vertSquashRatio
      )
      break
  }

  // Detects vertical squash in loaded image.
  // Fixes a bug which squash image vertically while drawing into canvas for some images.
  // This is a bug in iOS6 (and IOS7) devices. This function from https://github.com/stomita/ios-imagefile-megapixel
  function detectVerticalSquash(img) {
    var ih = img.naturalHeight
    var canvas = document.createElement("canvas")
    canvas.width = 1
    canvas.height = ih
    var ctx = canvas.getContext("2d")
    ctx.drawImage(img, 0, 0)
    var data = ctx.getImageData(0, 0, 1, ih).data
    // search image edge pixel position in case it is squashed vertically.
    var sy = 0,
      ey = ih,
      py = ih
    while (py > sy) {
      var alpha = data[(py - 1) * 4 + 3]
      if (alpha === 0) {
        ey = py
      } else {
        sy = py
      }
      py = (ey + sy) >> 1
    }
    var ratio = py / ih
    return ratio === 0 ? 1 : ratio
  }
}


function dataURL2Blob(dataURI) {
  var byteStr, intArray, ab, i, mimetype, parts

  parts = dataURI.split(",")

  if (~parts[0].indexOf("base64")) {
    byteStr = atob(parts[1])
  } else {
    byteStr = decodeURIComponent(parts[1])
  }

  ab = new ArrayBuffer(byteStr.length)
  intArray = new Uint8Array(ab)

  for (i = 0; i < byteStr.length; i++) {
    intArray[i] = byteStr.charCodeAt(i)
  }

  mimetype = parts[0].split(":")[1].split(";")[0]

  return arrayBufferToBlob(ab, mimetype)
}
function arrayBufferToBlob(buffer, type) {
  var builder = window.BlobBuilder || window.WebKitBlobBuilder,
    bb

  // android不支持直接new Blob, 只能借助blobbuilder.
  if (builder) {
    bb = new builder()
    bb.append(buffer)
    return bb.getBlob(type)
  }

  return new Blob([buffer], type ? { type: type } : {})
}

const ImageUpload = function(file, options) {
  this.options = Object.assign(
    {
      quality: 0.8,
      imageMinZoomWidth: 540,
      onUpload() {},
      onError() {},
      fileKey: "file",
      ext: false,
      data: {}
    },
    options
  )
  this.file = file
}

ImageUpload.prototype = {
  constructor: ImageUpload,
  start(imageUploadDatabase) {
    imageUploadDatabase.img = document.createElement("img")
    imageUploadDatabase.img.onload = this.imageLoad.bind(
      this,
      imageUploadDatabase
    )
    imageUploadDatabase.img.src = URL.createObjectURL(imageUploadDatabase.file)
  },
  imageLoad(imageUploadDatabase) {
    var img = imageUploadDatabase.img
    var self = this

    EXIF.getData(imageUploadDatabase.file, function() {
      var orientation = EXIF.getTag(this, "Orientation")
      self.drawImage(img, orientation, imageUploadDatabase)
    })
  },
  drawImage(img, orientation, imageUploadDatabase) {
    var options = imageUploadDatabase.options

    //生成比例
    var w = img.width,
      h = img.height,
      scale = w / h
    w = w > options.imageMinZoomWidth ? options.imageMinZoomWidth : w
    h = w / scale
    //生成canvas

    var canvas = document.createElement("canvas")
    var ctx = canvas.getContext("2d")
    canvas.width = w
    canvas.height = h
    var styleWidth = canvas.style.width
    var styleHeight = canvas.style.height
    if (orientation > 4) {
      canvas.width = h
      canvas.style.width = styleHeight
      canvas.height = w
      canvas.style.height = styleWidth
    }
    switch (orientation) {
      case 2:
        ctx.translate(w, 0)
        ctx.scale(-1, 1)
        break
      case 3:
        ctx.translate(w, h)
        ctx.rotate(Math.PI)
        break
      case 4:
        ctx.translate(0, h)
        ctx.scale(1, -1)
        break
      case 5:
        ctx.rotate(0.5 * Math.PI)
        ctx.scale(1, -1)
        break
      case 6:
        ctx.rotate(0.5 * Math.PI)
        ctx.translate(0, -h)
        break
      case 7:
        ctx.rotate(0.5 * Math.PI)
        ctx.translate(w, -h)
        ctx.scale(-1, 1)
        break
      case 8:
        ctx.rotate(-0.5 * Math.PI)
        ctx.translate(-w, 0)
        break
    }
    
    if (isIOS) { // fix iOS 
      drawImageIOSFix(ctx, img, 0, 0, img.width, img.height, 0, 0, w, h)
    } else {
      ctx.drawImage(img, 0, 0, img.width, img.height, 0, 0, w, h)
    }
    const base64 = canvas.toDataURL("image/jpeg", options.quality)
    const formBlob = this.getSource(base64, imageUploadDatabase)
    if (options.ext) {
      options.onBeforeUpload && options.onBeforeUpload(imageUploadDatabase.img.src)
      this.uploadFile(formBlob)
    } else {
      options.onUpload(base64)
    }
  },
  getSource(base64, imageUploadDatabase) {
    var blob = dataURL2Blob(base64)
    var file = imageUploadDatabase.file
    if (blob.size < imageUploadDatabase.file.size) {
      return new window.File([blob], file.name, { type: file.type })
    } else {
      return file
    }
  },
  uploadFile(formBlob) {
    var xhr = new XMLHttpRequest()
    var fd = new FormData()
    var options = this.options
    xhr.open("POST", options.url, true)
    xhr.onreadystatechange = function() {
      if (xhr.readyState == 4 && xhr.status == 200) {
        if (xhr.status == 200) {
          var res = JSON.parse(xhr.responseText)
          options.onUpload(res)
        } else {
          options.onError()
        }
      }
    }
    options.data[options.fileKey] = formBlob
    for (var i in options.data) {
      fd.append(i, options.data[i])
    }
    xhr.send(fd)
  }
}

function isEmptyObject(object) {
  for (var attr in object) {
    return false
  }

  return true
}

let exitsImageUploads = Object.create(null)

const ImageUploadFactory =  {
  createImageUpload(file, options) {
    if (isEmptyObject(exitsImageUploads)) {
      const imageUpload = new ImageUpload(file, options)
      exitsImageUploads = imageUpload
      return imageUpload
    } else {
      exitsImageUploads.options.extData = options.extData
      exitsImageUploads.options.data = options.data || {}
      return exitsImageUploads
    }
  }
}

const ImageUploadManager = {
  start(file, options) {
    const imageUpload = ImageUploadFactory.createImageUpload(file, options)
    imageUpload.start({ file, options })
    return imageUpload
  },
  destroyed() {
    exitsImageUploads = Object.create(null)
  }
}

export default ImageUploadManager
